SA.Number = {
    countDecimalPlaces(number) {
        var fraction = String(Number(number)).split('.')[1];

        return fraction ? fraction.length : 0;
    },

    getFormatterWithConsistentDecimalsPerSuffix(values) {
        var decimalPlaces = new Map();

        values.forEach(value => {
            var {mantissa, suffix} = SA.Number.toMantissaAndThousandSuffix(value),
                decimalCount = SA.Number.countDecimalPlaces(mantissa);

            decimalPlaces.set(suffix, Math.max(decimalCount, decimalPlaces.get(suffix) || 0));
        });

        return value => {
            var {mantissa, suffix} = SA.Number.toMantissaAndThousandSuffix(value),
                decimals = decimalPlaces.get(suffix);

            return mantissa.toFixed(decimals) + suffix;
        };
    },

    toMantissaAndThousandSuffix(number) {
        var power = SA.PowersOfThousand.getPower(number),
            mantissa = SA.PowersOfThousand.toPower(number, power),
            suffix = SA.PowersOfThousand.getSuffix(power);

        return {mantissa, suffix};
    }
};